import React from 'react';
import * as R from 'ramda';
import {present} from '@/util';
import {useTranslation} from 'react-i18next';

import BreakDownChart from '@/b2c/PlanDetail/Detail/BreakDownChart';

const showDisclaimer5 = ({siteCode, isAdditionalFundExist}) =>
  R.cond([
    [R.equals('afs'), R.always(R.not(isAdditionalFundExist))],
    [R.T, () => false],
  ])(siteCode);

const Portfolio = ({
  currentPlan: {
    portfolio,
    companyName,
    siteCode,
    isAdditionalFundExist,
    additionalHoldings: {abfFund, etfFund},
  },
}) => {
  const {t: tr} = useTranslation('statements');

  return (
    <>
      {present(portfolio) && (
        <BreakDownChart type='portfolio' data={portfolio} />
      )}
      <section className='note'>
        <p className='desc'>{tr('disclaimer_2')}</p>
        <p className='desc'>{tr('disclaimer_3', {companyName})}</p>
        <p className='desc'>{tr('disclaimer_4')}</p>
        {showDisclaimer5({siteCode, isAdditionalFundExist}) && (
          <p className='desc'>{tr('disclaimer_5', {companyName})}</p>
        )}
      </section>
      {present(abfFund) && <BreakDownChart type='abfFund' data={abfFund} />}
      {present(etfFund) && <BreakDownChart type='etfFund' data={etfFund} />}
    </>
  );
};

export default Portfolio;
